import {Link} from 'react-router-dom';
import { Home,Package,CreditCard,ToggleRight,Activity,Settings,Power, Users, Lock, User, Share2, MessageCircle, Gift, ExternalLink, Truck, Plus, Percent, Clipboard, RefreshCcw, Info, List, Repeat, Monitor, BarChart2, GitMerge, Key, Star} from 'react-feather';
import React, { useEffect, useState } from 'react';
import api from "../api";
import { useLocation } from 'react-router-dom';
import { FaCashRegister, FaCrown, FaNetworkWired, FaPrint, FaWarehouse } from "react-icons/fa";
import WithPermission from './WithPersmission';
import { useSubscription } from "../../useSubscription"; 
function Sidebar(){
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [statsLoading, setstatsLoading] = useState(false);
    const location = useLocation();
    const [VendorData, setVendorData] = useState({
        'totalProducts': 0,
        'totalOrders': 0,
        'totalCustomers': 0,
        'name': '',
        'rr': '',
        'website': '',
    });
    const isSellerPage = location.pathname.startsWith('/seller/') &&  !['/seller/login', '/seller/register'].includes(location.pathname);
    const fetchData = async () => {
        try {
          const response = await api.get(`${baseUrl}/vendor-dashboard/`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          });
          setVendorData(response.data);
          localStorage.setItem('VendorCurrency', response.data.currency);
        } catch (err) {
          //console.error("Error fetching products:", err.toJSON());
        }
    };
    const vendor_username = localStorage.getItem('vendor_username');
    const vendor_shopname = localStorage.getItem('vendor_shopname');
    const {
        packageDetails,
        isFree,
        isPremium,
        isGrowth,
        isLoading: subscriptionLoading
    } = useSubscription();

    useEffect(() => {  
        if(isSellerPage && localStorage.getItem("access_token") != null){
            fetchData();
        }     
    }, []);

    
    // Update localStorage whenever VendorData changes
    useEffect(() => {
        localStorage.setItem('VendorData', JSON.stringify(VendorData));        
    }, [VendorData]);

    var status_pay = 1;
    if(packageDetails == null || packageDetails.status === "0"){
        status_pay = 0;
    }else if(packageDetails.package_name === "Personal"){
        status_pay = 0;
    }else{status_pay = 1;}

    var status_pay_lv1 = 0;
    if(isGrowth){
        status_pay_lv1 = 1;
    }

    var status_pay_lv2 = 0;
    if(isPremium){
        status_pay_lv2 = 1;
    }

    return ( 
        <ul className="navbar-nav flex-column w-100">     
            <li className="nav-divider pl-0 pr-0 hidemobile">                     
                <Link
                    to={`${VendorData.website}`}
                    target="_blank"
                    className="nav-link d-flex align-items-center justify-content-between p-2 rounded-3 bg-white text-decoration-none shadow-tile"
                    style={{ maxWidth: "280px" }}
                    >
                    {/* Left section */}
                    <div className="d-flex align-items-center">
                        
                        {/* Icon */}
                        <div
                            className="d-flex align-items-center justify-content-center me-2"
                            style={{
                                width: "36px",
                                height: "36px",
                                borderRadius: "5px",
                                background: "rgb(0, 48, 110)", // soft purple
                                color: "#fff",
                                fontWeight: "600"
                            }}
                        >
                            {vendor_shopname?.charAt(0)?.toUpperCase() || "A"}
                        </div>

                        {/* Text */}
                        <div className="lh-sm">
                        <div style={{ fontSize: "0.7em", color: "#9ca3af" }}>
                            Visit Shop
                        </div>
                        <div style={{ fontSize: "14px", fontWeight: "600", color: "rgb(0, 48, 110)" }}>
                            {vendor_shopname}
                        </div>
                        </div>
                    </div>

                    {/* Right icon */}
                    <div className="text-muted">
                        <ExternalLink size={16} style={{ color: "rgb(0, 48, 110)" }}/>
                    </div>
                </Link>
            </li>
            <li className="nav-item">
                <Link to="/seller/dashboard" className="nav-link" aria-current="true"><Home/> Dashboard</Link>
            </li> 
            
            {VendorData.rr && VendorData.rr !== 0 ? (
                <WithPermission permission="Orders" rights={VendorData.rr}>
                    <li className="nav-item">
                        <Link to="/seller/orders" className="nav-link" aria-current="true"><Gift/> Orders <span className="nav-ord-span">{VendorData.totalOrders}</span></Link>
                    </li>  
                </WithPermission>
            ) : (
                <li className="nav-item">
                    <Link to="/seller/orders" className="nav-link" aria-current="true"><Gift/> Orders <span className="nav-ord-span">{VendorData.totalOrders}</span></Link>
                </li>  
            )}   
                  
            {VendorData.rr && VendorData.rr !== 0 ? (
                <WithPermission permission="Stock" rights={VendorData.rr}>
                    <li className="nav-item">
                        <Link to="/seller/pos" className="nav-link" aria-current="true"><FaCashRegister/> POS Lite</Link>
                    </li> 
                </WithPermission>
            ) : (
                <li className="nav-item">
                    <Link to="/seller/pos" className="nav-link" aria-current="true"><FaCashRegister/> POS Lite</Link>
                </li> 
            )}              
            
            {VendorData.rr == 0 && 
                <li className="nav-item display-none">
                    <Link to="/bizdocs/dashboard" className="nav-link" aria-current="true"><FaPrint/> Smart Desk</Link>
                </li> 
            } 

            
            {VendorData.rr && VendorData.rr !== 0 ? (
                <WithPermission permission="Stock" rights={VendorData.rr}>
                    <li className="nav-item">
                        <Link to="/seller/products" className="nav-link" aria-current="true"><Package/> Products</Link>
                    </li> 
                </WithPermission>
            ) : (
                <li className="nav-item">
                    <Link to="/seller/products" className="nav-link" aria-current="true"><Package/> Products</Link>
                </li> 
            )}

            {VendorData.rr && VendorData.rr !== 0 ? (
                <WithPermission permission="Stock" rights={VendorData.rr}>
                    <li className="nav-item">
                        <Link to="/seller/manage-offers" className="nav-link" aria-current="true"><Percent/> Manage Discounts</Link>
                    </li> 
                </WithPermission>
            ) : (
                <li className="nav-item">
                    <Link to="/seller/manage-offers" className="nav-link" aria-current="true"><Percent/> Manage Discounts</Link>
                </li> 
            )}

            {status_pay_lv2 === 0 ? (
                <>  
                    {VendorData.rr && VendorData.rr !== 0 ? (
                        <WithPermission permission="Customers" rights={VendorData.rr}>
                            <li className="nav-item">
                                <Link to="/seller/subscription" className="nav-link" aria-current="true"><Clipboard/> Customers <FaCrown className="upgrade-icon"/></Link>
                            </li>
                        </WithPermission>
                    ) : (
                        <li className="nav-item">
                            <Link to="/seller/subscription" className="nav-link" aria-current="true"><Clipboard/> Customers <FaCrown className="upgrade-icon"/></Link>
                        </li>
                    )}
                </>
            ) : (
                <>
                    {VendorData.rr && VendorData.rr !== 0 ? (
                        <WithPermission permission="Customers" rights={VendorData.rr}>
                            <div className="accordion accordion-flush" id="accordionFlushExample">
                                <div className="accordion-item br10">
                                    <li className="nav-item accordion-button mobile-nav-hd-fff collapsed text-blue" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne112" aria-controls="flush-collapseOne112">
                                        <Link to="#" className="nav-link" aria-current="true"><Clipboard/> Customers</Link>
                                    </li>
                                    <div id="flush-collapseOne112" className="accordion-collapse collapse pb-2 pt-0" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            <li className="nav-item">
                                                <Link to="/seller/customers" className="nav-link" aria-current="true"><Users/> Overview</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/seller/reviews" className="nav-link" aria-current="true"><MessageCircle/> Reviews</Link>
                                            </li>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                        </WithPermission>
                    ) : (
                        <div className="accordion accordion-flush" id="accordionFlushExample">
                            <div className="accordion-item br10">
                                <li className="nav-item accordion-button mobile-nav-hd-fff collapsed text-blue" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne112" aria-controls="flush-collapseOne112">
                                    <Link to="#" className="nav-link" aria-current="true"><Clipboard/> Customers</Link>
                                </li>
                                <div id="flush-collapseOne112" className="accordion-collapse collapse pb-2 pt-0" data-bs-parent="#accordionFlushExample">
                                    <div className="accordion-body">
                                        <li className="nav-item">
                                            <Link to="/seller/customers" className="nav-link" aria-current="true"><Users/> Overview</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link to="/seller/reviews" className="nav-link" aria-current="true"><MessageCircle/> Reviews</Link>
                                        </li>
                                    </div>
                                </div>
                            </div>
                        </div> 
                    )}
                </>
            )}   

            {VendorData.rr && VendorData.rr !== 0 ? (
                <WithPermission permission="Stock" rights={VendorData.rr}>
                    <li className="nav-item">
                        <Link to="/seller/reports" className="nav-link" aria-current="true"><Activity/> Analytics</Link>
                    </li> 
                </WithPermission>
            ) : (
                <li className="nav-item">
                    <Link to="/seller/reports" className="nav-link" aria-current="true"><Activity/> Analytics</Link>
                </li> 
            )}

            {VendorData.rr && VendorData.rr !== 0 ? (
                <WithPermission permission="Staff" rights={VendorData.rr}>
                    <>
                        {status_pay_lv1 === 0 ? (
                            <>
                                <li className="nav-item">
                                    <Link to="/seller/subscription" className="nav-link" aria-current="true"><RefreshCcw/> Advanced Agent <FaCrown className="upgrade-icon"/></Link>
                                </li>
                            </>
                        ) : (
                            <>
                                <li className="nav-item">
                                    <Link to="/seller/retarget" className="nav-link" aria-current="true"><RefreshCcw/> Advanced Agent</Link>
                                </li>
                            </>
                        )}
                    </>
                </WithPermission>
            ) : (
                <>
                    {status_pay_lv1 === 0 ? (
                        <>
                            <li className="nav-item">
                                <Link to="/seller/subscription" className="nav-link" aria-current="true"><RefreshCcw/> Advanced Agent <FaCrown className="upgrade-icon"/></Link>
                            </li>
                        </>
                    ) : (
                        <>
                            <li className="nav-item">
                                <Link to="/seller/retarget" className="nav-link" aria-current="true"><RefreshCcw/> Advanced Agent</Link>
                            </li>
                        </>
                    )}
                </>
            )}           
            

            {VendorData.rr && VendorData.rr !== 0 ? (
                <WithPermission permission="Staff" rights={VendorData.rr}>
                    <>
                        {status_pay_lv1 === 0 ? (
                            <>
                                <li className="nav-item">
                                    <Link to="/seller/subscription" className="nav-link" aria-current="true"><FaNetworkWired/> Employees <FaCrown className="upgrade-icon"/></Link>
                                </li>
                            </>
                        ) : (
                            <>
                                <li className="nav-item">
                                    <Link to="/seller/staff" className="nav-link" aria-current="true"><FaNetworkWired/> Employees</Link>
                                </li>
                            </>
                        )}
                    </>
                </WithPermission>
            ) : (
                <>
                    {status_pay_lv1 === 0 ? (
                        <>
                            <li className="nav-item">
                                <Link to="/seller/subscription" className="nav-link" aria-current="true"><FaNetworkWired/> Employees <FaCrown className="upgrade-icon"/></Link>
                            </li>
                        </>
                    ) : (
                        <>
                            <li className="nav-item">
                                <Link to="/seller/staff" className="nav-link" aria-current="true"><FaNetworkWired/> Employees</Link>
                            </li>
                        </>
                    )}
                </>
            )}
                                   
            

            {VendorData.rr && VendorData.rr !== 0 ? (
                <WithPermission permission="Finance" rights={VendorData.rr}>
                    <li className="nav-item">
                        <Link to="/seller/finance" className="nav-link" aria-current="true">
                            <CreditCard /> Finance
                        </Link>
                    </li>
                </WithPermission>
            ) : (
                <div className="accordion accordion-flush" id="accordionFlushExample">
                    <div className="accordion-item br10">
                        <li className="nav-item accordion-button mobile-nav-hd-fff collapsed text-blue" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne1120" aria-controls="flush-collapseOne1120">
                            <Link to="#" className="nav-link" aria-current="true"><CreditCard/> Finance</Link>
                        </li>
                        <div id="flush-collapseOne1120" className="accordion-collapse collapse pb-2 pt-0" data-bs-parent="#accordionFlushExample">
                            <div className="accordion-body">
                                <li className="nav-item">
                                    <Link to="/seller/finance" className="nav-link" aria-current="true"><Info/> Account Details</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/seller/payment-method" className="nav-link" aria-current="true"><Repeat/> Payment Method</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/seller/settlement" className="nav-link" aria-current="true"><List/> Settlement Overview</Link>
                                </li>
                            </div>
                        </div>
                    </div>
                </div>
            )}             

            {status_pay_lv2 === 0 ? (
                <>  
                    {VendorData.rr && VendorData.rr !== 0 ? (
                        <WithPermission permission="Customers" rights={VendorData.rr}>
                            <li className="nav-item">
                                <Link to="/seller/subscription" className="nav-link" aria-current="true"><GitMerge/> Integrations <FaCrown className="upgrade-icon"/></Link>
                            </li>
                        </WithPermission>
                    ) : (
                        <li className="nav-item">
                            <Link to="/seller/subscription" className="nav-link" aria-current="true"><GitMerge/> Integrations <FaCrown className="upgrade-icon"/></Link>
                        </li>
                    )}
                </>
            ) : (
                <>
                    {VendorData.rr && VendorData.rr !== 0 ? (
                        <WithPermission permission="Customers" rights={VendorData.rr}>
                            <div className="accordion accordion-flush" id="accordionFlushExample">
                                <div className="accordion-item br10">
                                    <li className="nav-item accordion-button mobile-nav-hd-fff collapsed text-blue" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne11212" aria-controls="flush-collapseOne11212">
                                        <Link to="#" className="nav-link" aria-current="true"><GitMerge/> Integrations</Link>
                                    </li>
                                    <div id="flush-collapseOne11212" className="accordion-collapse collapse pb-2 pt-0" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            <li className="nav-item">
                                                <Link to="/seller/getapikey" className="nav-link" aria-current="true"><Key/> ApiKey</Link>
                                            </li>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                        </WithPermission>
                    ) : (                        
                        <div className="accordion accordion-flush" id="accordionFlushExample">
                            <div className="accordion-item br10">
                                <li className="nav-item accordion-button mobile-nav-hd-fff collapsed text-blue" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne11212" aria-controls="flush-collapseOne11212">
                                    <Link to="#" className="nav-link" aria-current="true"><GitMerge/> Integrations</Link>
                                </li>
                                <div id="flush-collapseOne11212" className="accordion-collapse collapse pb-2 pt-0" data-bs-parent="#accordionFlushExample">
                                    <div className="accordion-body">
                                        <li className="nav-item">
                                            <Link to="/seller/getapikey" className="nav-link" aria-current="true"><Key/> ApiKey</Link>
                                        </li>
                                    </div>
                                </div>
                            </div>
                        </div> 

                    )}
                </>
            )}
            
            {VendorData.rr && VendorData.rr !== 0 ? (
                <WithPermission permission="Account Management" rights={VendorData.rr}>
                    <div className="accordion accordion-flush mb-6" id="accordionFlushExample">
                        <div className="accordion-item br10">
                            <li className="nav-item accordion-button mobile-nav-hd-fff collapsed text-blue" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-controls="flush-collapseOne">
                                <Link to="/seller/reports" className="nav-link" aria-current="true"><Settings/> Settings</Link>
                            </li>
                            <div id="flush-collapseOne" className="accordion-collapse collapse pb-2 pt-0" data-bs-parent="#accordionFlushExample">
                                <div className="accordion-body">
                                    <li className="nav-item">
                                        <Link to="/seller/profile" className="nav-link" aria-current="true"><User/> Profile</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/seller/subscription" className="nav-link" aria-current="true"><ToggleRight/> Subscription</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/seller/delivery" className="nav-link" aria-current="true"><Truck/> Setup Delivery</Link>
                                    </li>
                                    {VendorData.rr && VendorData.rr !== 0 ? (
                                        <WithPermission permission="Staff" rights={VendorData.rr}>
                                            <>
                                                {status_pay_lv1 === 0 ? (
                                                    <>
                                                        <li className="nav-item">
                                                            <Link to="/seller/subscription" className="nav-link" aria-current="true"><FaNetworkWired/> Employees <FaCrown className="upgrade-icon"/></Link>
                                                        </li>
                                                    </>
                                                ) : (
                                                    <>
                                                        <li className="nav-item">
                                                            <Link to="/seller/staff" className="nav-link" aria-current="true"><FaNetworkWired/> Employees</Link>
                                                        </li>
                                                    </>
                                                )}
                                            </>
                                        </WithPermission>
                                    ) : (
                                        <>
                                            {status_pay_lv1 === 0 ? (
                                                <>
                                                    <li className="nav-item">
                                                        <Link to="/seller/subscription" className="nav-link" aria-current="true"><FaNetworkWired/> Employees <FaCrown className="upgrade-icon"/></Link>
                                                    </li>
                                                </>
                                            ) : (
                                                <>
                                                    <li className="nav-item">
                                                        <Link to="/seller/staff" className="nav-link" aria-current="true"><FaNetworkWired/> Employees</Link>
                                                    </li>
                                                </>
                                            )}
                                        </>
                                    )}
                                    <li className="nav-item">
                                        <Link to="/seller/reset-link" className="nav-link" aria-current="true"><Lock/> Change Password</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/seller/share" className="nav-link" aria-current="true"><Share2/> Share Shop</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/seller/logout" className="nav-link" aria-current="true"><Power/> Logout</Link>
                                    </li>
                                </div>
                            </div>
                        </div>
                    </div>
                </WithPermission>
            ) : (
                <div className="accordion accordion-flush mb-6" id="accordionFlushExample">
                    <div className="accordion-item br10">
                        <li className="nav-item accordion-button mobile-nav-hd-fff collapsed text-blue" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-controls="flush-collapseOne">
                            <Link to="/seller/reports" className="nav-link" aria-current="true"><Settings/> Settings</Link>
                        </li>
                        <div id="flush-collapseOne" className="accordion-collapse collapse pb-2 pt-0" data-bs-parent="#accordionFlushExample">
                            <div className="accordion-body">
                                <li className="nav-item">
                                    <Link to="/seller/profile" className="nav-link" aria-current="true"><User/> Profile</Link>
                                </li>  
                                <li className="nav-item">
                                    <Link to="/seller/subscription" className="nav-link" aria-current="true"><ToggleRight/> Subscription</Link>
                                </li>                              
                                {VendorData.rr && VendorData.rr !== 0 ? (
                                    <WithPermission permission="Staff" rights={VendorData.rr}>
                                        <>
                                            {status_pay_lv1 === 0 ? (
                                                <>
                                                    <li className="nav-item">
                                                        <Link to="/seller/subscription" className="nav-link hide" aria-current="true"><FaWarehouse/> Shelf <FaCrown className="upgrade-icon"/></Link>
                                                    </li>
                                                </>
                                            ) : (
                                                <>
                                                    <li className="nav-item">
                                                        <Link to="/seller/shelf" className="nav-link hide" aria-current="true"><FaWarehouse/> Shelf</Link>
                                                    </li>
                                                </>
                                            )}
                                        </>
                                    </WithPermission>
                                ) : (
                                    <>
                                        {status_pay_lv1 === 0 ? (
                                            <>
                                                <li className="nav-item">
                                                    <Link to="/seller/subscription" className="nav-link hide" aria-current="true"><FaWarehouse/> Shelf <FaCrown className="upgrade-icon"/></Link>
                                                </li>
                                            </>
                                        ) : (
                                            <>
                                                <li className="nav-item">
                                                    <Link to="/seller/shelf" className="nav-link hide" aria-current="true"><FaWarehouse/> Shelf</Link>
                                                </li>
                                            </>
                                        )}
                                    </>
                                )}
                                <li className="nav-item">
                                    <Link to="/seller/delivery" className="nav-link" aria-current="true"><Truck/> Setup Delivery</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/seller/reset-link" className="nav-link" aria-current="true"><Lock/> Change Password</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/seller/share" className="nav-link" aria-current="true"><Share2/> Share Shop</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/seller/logout" className="nav-link" aria-current="true"><Power/> Logout</Link>
                                </li>
                            </div>
                        </div>
                    </div>
                </div>
            )}
                        
        </ul>
    )
}

export default Sidebar;